import { CLIENT_TOKEN } from "shadow-client";

export const BEHAVIORS = {
  NOTHING: `/${CLIENT_TOKEN}/behaviors/nothing`,
  CONTACT_TAG: `/${CLIENT_TOKEN}/behaviors/contact_tag`,
  SUBSCRIPTION: `/${CLIENT_TOKEN}/behaviors/subscription`,
  SUBSCRIPTION_OPTION: `/${CLIENT_TOKEN}/behaviors/subscription_option`,
  TEST_SESSION: `/${CLIENT_TOKEN}/behaviors/special_offer_test_session`,
  COUNTER_LINE: `/${CLIENT_TOKEN}/behaviors/counter_line`,
  BADGE: `/${CLIENT_TOKEN}/behaviors/badge`
};



// WEBPACK FOOTER //
// ./src/shadow-client/endpoints/productApi/constants.js